import React from 'react';
import { CatalogItem } from '@/shared/types/catalog';
import { getSortedMoqInfo } from '@/shared/utils/sourcing-marketplace-util';
import './index.less';
import { first, isEmpty } from 'lodash-es';

interface IProps {
  product: CatalogItem;
  isServices?: boolean;
}

const CatalogItemProductionCost = ({ product, isServices }: IProps) => {
  const formatCurrency = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const renderPrice = (cost: number) => {
    return <span className="price">{formatCurrency.format(cost)}</span>;
  };

  const renderCost = () => {
    const moqInfo = getSortedMoqInfo(product);
    if (!isEmpty(moqInfo)) {
      const moq = first(moqInfo);
      return (
        <span>
          Produce {moq.qty} unit{moq.qty === 1 ? '' : 's'} for {renderPrice(moq.price)}/each
        </span>
      );
    }

    const sampleCost: number = product.displayPrice;
    if (sampleCost > 0) {
      return (
        <span>
          {isServices ? 'Starting at ' : 'Sample for '} {renderPrice(sampleCost)}
        </span>
      );
    }

    return <span>Request a quote</span>;
  };

  return <div className="catalog-item-production-cost">{renderCost()}</div>;
};

export default CatalogItemProductionCost;
